import { GameApplicationType } from '../enums';

export const getScreenResolution = (mode) => {
  const { innerWidth, innerHeight } = window;
  let width = innerWidth;
  let height;
  switch (mode) {
    case GameApplicationType.mobile:
      height = width * 16 / 9;
      return {
        height,
        width,
      };
    case GameApplicationType.web:
    default:
      height = width * 9 / 16;
      if (height > innerHeight) {
        height = innerHeight;
        width = height * 16 / 9;
      }
      return {
        height,
        width,
      };
  }
};
